import { render } from "./dentrion_rate.vue?vue&type=template&id=5bf589fb&scoped=true"
import script from "./dentrion_rate.vue?vue&type=script&lang=js"
export * from "./dentrion_rate.vue?vue&type=script&lang=js"

import "./dentrion_rate.vue?vue&type=style&index=0&id=5bf589fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf589fb"]])

export default __exports__